export default
{
  'brython': {
    highlight: 'python',
    javascript: true
  },
  'filament': {
    highlight: 'python',
    javascript: true
  },
  'go': {
    highlight: 'go',
    transform: 'gopherjs',
    javascript: true
  },
  'javascript': {
    highlight: 'javascript',
    javascript: true
  },
  'typescript': {
    highlight: 'TypeScript',
    javascript: true
  },
  'react': {
    highlight: 'javascript',
    javascript: true
  },
  'd3': {
    highlight: 'javascript',
    javascript: true
  },
  'leaflet': {
    highlight: 'javascript',
    javascript: true
  },
  'plotly': {
    highlight: 'javascript',
    javascript: true
  },
  'openjscad': {
    highlight: 'javascript',
    javascript: true
  },
  'stdlib': {
    highlight: 'javascript',
    javascript: true
  },
  'three': {
    highlight: 'javascript',
    javascript: true
  },
  'p5js': {
    highlight: 'javascript',
    javascript: true
  },
  'P5JS': {
    highlight: 'javascript',
    javascript: true
  },
  'smartdown': {
    highlight: 'markdown',
    javascript: false
  },
  'graphviz': {
    highlight: 'graphviz',
    javascript: false
  },
  'abc': {
    highlight: 'abc',
    javascript: false
  },
  'abcmidi': {
    highlight: 'abc',
    javascript: false
  },
  'abcsheet': {
    highlight: 'abc',
    javascript: false
  },
  'mermaid': {
    highlight: 'mermaid',
    javascript: false
  }
};
